module.exports = __webpack_public_path__ + "img/right_worm_wheel.prt.b610cb16.jpg";